// extracted by mini-css-extract-plugin
export default {"container":"notallowed_container__4ZzwH","returnButton":"notallowed_returnButton__pn3hC"};